module.exports = __webpack_public_path__ + "static/media/security.1f8dc89a.svg";